import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import useStyles from './CartaScanSummary.style'

const propTypes = {
    value: PropTypes.string,
    isAnswered: PropTypes.bool,
    onRetry: PropTypes.func,
}

const defaultProps = {
    value: '',
    isAnswered: false,
    onRetry: undefined,
}

const CartaScanSummary = ({
    isAnswered,
    value,
    onRetry,
}) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <div className={classes.root}>
            { !isAnswered && t('NO_SCAN_PERFORMED') }
            { isAnswered && `${t('SELECTED_CARTA_LOGGER')} ${value}` }
            { onRetry && (
                <div className={classes.actions}>
                    <Button
                        data-testid="retry-button"
                        className={classes.button}
                        onClick={onRetry}
                    >
                        {t('RETRY')}
                    </Button>
                </div>
            )}
        </div>
    )
}

CartaScanSummary.propTypes = propTypes
CartaScanSummary.defaultProps = defaultProps

export default CartaScanSummary
